var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11438 5.9992V11.2493C4.0928 11.4781 4.15754 11.6601 4.30694 11.797C4.45799 11.9323 4.62398 12 4.80658 12C4.98917 12 5.15516 11.9372 5.30622 11.8131L6.65906 10.4696C6.83004 10.3037 6.9064 10.1152 6.88482 9.90737V6.00081L10.8454 1.09384C10.9749 0.947241 11.023 0.781313 10.9898 0.594442C10.9566 0.407572 10.872 0.260975 10.7325 0.156263C10.5931 0.0515506 10.4487 0 10.2976 0H0.701556C0.550502 0 0.406088 0.0515506 0.266653 0.156263C0.127218 0.260975 0.0409018 0.40435 0.00936307 0.592831C-0.0221757 0.781313 0.0259624 0.947241 0.153777 1.09223L4.11438 5.9992Z",
    fill: "#444F59",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnFilter);
export default __webpack_public_path__ + "static/media/column_filter.8c898d83571c530e4707be7299b9cf25.svg";
export { ForwardRef as ReactComponent };